'use client';
import { Site } from "@/types/sites";
import Script from 'next/script';

export const Convert = ({ site }: { site: Site | null }) => {
    const convertId = site?.attributes?.third_party_scripts?.ConvertAppId;
    const projectId = site?.attributes?.third_party_scripts?.ConvertProjectId;

    if (!convertId || !projectId) {
        return null;
    }

    return (
        <Script
            src={`//cdn-4.convertexperiments.com/v1/js/${convertId}-${projectId}.js?environment=production`}
            type="text/javascript"
            strategy="afterInteractive"
        />
    );
};